import React from 'react';
import { useSelector } from 'react-redux';
import { mostPopularImageConfig } from '../../common/helpers/sharpie/sharpie';
import { getPostCategoryInThai } from '../../common/helpers/domain/postCategories';
import { getContentPagePath } from '../../common/helpers/routing/urlGenerator';
import { handleImageUrl } from '../../common/helpers/sharpie/imageUrlHelper';
import { MostPopular } from '../../queries/homePage/mostPopular';
import { WholeState as CommonState } from '../../store/common/type';
import {
  MostPopularCardWrapper,
  MostPopularPostCategoryWrapper,
  MostPopularPostImageWrapper,
  MostPopularPostTitleWrapper,
} from './MostPopularCard.style';

export interface MostPopularCardProps {
  post: MostPopular;
  onClick?: (post: MostPopular) => void;
}

const MostPopularCard: React.FC<MostPopularCardProps> = ({ post, onClick }) => {
  const { title, postCategory, link, featuredImage } = post;
  const url = getContentPagePath({ link });
  const isNextGenSupported = useSelector<CommonState, boolean>((state) =>
    state.common !== undefined ? state.common.isNextGenSupported : false,
  );

  const sharpieImgUri = handleImageUrl(
    featuredImage?.url ?? '',
    mostPopularImageConfig.width,
    mostPopularImageConfig.height,
    isNextGenSupported,
  );

  return (
    <MostPopularCardWrapper
      data-test="most-popular-item"
      onClick={() => onClick(post)}
    >
      <MostPopularPostImageWrapper href={url}>
        <img src={sharpieImgUri} alt={title} />
      </MostPopularPostImageWrapper>
      <div>
        <MostPopularPostCategoryWrapper data-test="most-popular-category">
          <a href={url}>{getPostCategoryInThai(postCategory)} </a>
        </MostPopularPostCategoryWrapper>
        <MostPopularPostTitleWrapper
          id="most-popular-title"
          data-test="most-popular-title"
        >
          <a href={url} title={title}>
            {title}
          </a>
        </MostPopularPostTitleWrapper>
      </div>
    </MostPopularCardWrapper>
  );
};

export default MostPopularCard;
